import React from 'react';
import "./PasswordStrengthChecklist.scss";
import {PropTypes} from 'prop-types';
import {PASSWORD_REQUIREMENTS} from "./constants/PasswordRequirements";
import PasswordChecklistItem from "./PasswordChecklistItem";

const PasswordStrengthChecklist = (props) => {

  let listItems = PASSWORD_REQUIREMENTS.map((item)=> {
    let requirementMet = props.requirementsMet.indexOf(item.requirement) >= 0;
    return <PasswordChecklistItem key={item.requirement} item={item} isMet={requirementMet}/>;
  });
  
  return (
      <div className="strength-checklist-container">
        {props.showChecklist &&
        <div className="strength-checklist">
          {listItems}
        </div>
        }
      </div>

  )
};

PasswordStrengthChecklist.propTypes = {
  requirementsMet: PropTypes.array.isRequired,
  showChecklist: PropTypes.bool.isRequired
};

export default PasswordStrengthChecklist;